import script from "./dialog-opening-hours.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-opening-hours.vue?vue&type=script&setup=true&lang=js"

import "./dialog-opening-hours.vue?vue&type=style&index=0&id=1e6d4797&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6d4797"]])

export default __exports__